import React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import cn from 'clsx';
import styles from './index.module.scss';

type Props = {
    valueToColorMap: Record<string | number, string>;
};

const CreateBadgeCell = ({ valueToColorMap }: Props) => {
    return function BadgeCell({ tdProps, children }: GridCustomCellProps) {
        // `children` is likely just a string/number
        const value = typeof children === 'string' || typeof children === 'number' ? children : undefined;

        const backgroundColor = value != null ? valueToColorMap[value] : undefined;

        return (
            <td {...tdProps} className={cn(tdProps?.className, styles.badgeCell)}>
                <div className={styles.badgeCellContent} style={{ backgroundColor }}>
                    {children}
                </div>
            </td>
        );
    };
};

export const CreateDataListingChangeStateBadgeCell = () => {
    return CreateBadgeCell({
        valueToColorMap: {
            New: 'rgb(193 77 195 / 41%)',
            Unchanged: 'rgb(39 144 242 / 30%)',
            Changed: 'rgb(255 110 32 / 20%)',
        },
    });
};

export default CreateBadgeCell;
